import type { DefaultObject } from '@moniebook-web/types';
import { getBaseService } from '@moniebook-web/utils';

const ENABLE_MONITORING = process.env.ENABLE_MONITORING ?? 'true';
const ENVIRONMENT = process.env.ENVIRONMENT ?? 'development';

// Customer analytics configs
const CUSTOMER_ANALYTICS_SERVICE = process.env.CUSTOMER_ANALYTICS_SERVICE ?? '';
const MIXPANEL_PROJECT_TOKEN = process.env.MIXPANEL_PROJECT_TOKEN ?? '';
const APPLICATION_ID = process.env.APPLICATION_ID ?? '';
const MIXPANEL_RECORD_MASK_TEXT_SELECTOR =
    process.env.MIXPANEL_RECORD_MASK_TEXT_SELECTOR ?? '';
const MIXPANEL_RECORD_BLOCK_SELECTOR =
    process.env.MIXPANEL_RECORD_BLOCK_SELECTOR ?? '';
const CUSTOMER_ANALYTICS_ENVIRONMENT =
    process.env.CUSTOMER_ANALYTICS_ENVIRONMENT ?? 'dev';
// end customer analytics configs

// Braze configs
const BRAZE_API_KEY = process.env.BRAZE_API_KEY ?? '';
const BRAZE_BASE_URL = process.env.BRAZE_BASE_URL ?? '';
// end braze configs

const serviceUrl: DefaultObject = {
    ENABLE_MONITORING,
    ENVIRONMENT,
    CUSTOMER_ANALYTICS_SERVICE,
    MIXPANEL_PROJECT_TOKEN,
    APPLICATION_ID,
    MIXPANEL_RECORD_MASK_TEXT_SELECTOR,
    MIXPANEL_RECORD_BLOCK_SELECTOR,
    CUSTOMER_ANALYTICS_ENVIRONMENT,
    BRAZE_API_KEY,
    BRAZE_BASE_URL,
};

const getService = getBaseService(serviceUrl);

export const config = {
    ENABLE_MONITORING: getService('ENABLE_MONITORING'),
    ENVIRONMENT: getService('ENVIRONMENT'),
    NEWRELIC: {
        applicationId: getService('TELEMETRY_NEWRELIC_APP_ID'),
        licenseKey: getService('TELEMETRY_NEWRELIC_LICENSE_KEY'),
    },
    MIXPANEL: {
        token: getService('MIXPANEL_PROJECT_TOKEN'),
        record_sessions_percent: 1,
        record_mask_text_selector: getService(
            'MIXPANEL_RECORD_MASK_TEXT_SELECTOR',
        ),
        record_block_selector: getService('MIXPANEL_RECORD_BLOCK_SELECTOR'),
    },
    BRAZE: {
        apiKey: getService('BRAZE_API_KEY'),
        baseUrl: getService('BRAZE_BASE_URL'),
    },
    CUSTOMER_ANALYTICS_SERVICE: getService('CUSTOMER_ANALYTICS_SERVICE'),
    APPLICATION_ID: getService('APPLICATION_ID'),
    CUSTOMER_ANALYTICS_ENVIRONMENT: getService(
        'CUSTOMER_ANALYTICS_ENVIRONMENT',
    ),
};
